@import '../../styles/modals.css';
@import '../../styles/buttons.css';

.confirmation-message {
  font-size: 14px;
  padding: 16px;
}

.tambr-action-buttons {
  padding: 0 16px 16px 16px;
}